import React from 'react';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  subtitle?: string;
  cta?: React.ReactNode;
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ 
  icon,
  title, 
  subtitle, 
  cta,
  className = "" 
}) => {
  return (
    <div className={`flex flex-col text-eoe-text-sub dark:text-eoe-dark-text-sub text-center gap-2 p-4 ${className}`}>
      {icon && (
        <div className="empty-state-icon items-center justify-center text-eoe-text-heading dark:text-eoe-dark-text-heading flex [&_svg]:size-12">
          {icon}
        </div>
      )}
      <div className="font-semibold text-xl text-eoe-text-heading dark:text-eoe-dark-text-heading">{title}</div>
      {subtitle && (
        <span className="text-sm">
          {subtitle}
        </span>
      )}
      {cta ? (
        <div className="mt-2 flex justify-center">
          {cta}
        </div>
      ) : null}
    </div>
  );
};

export default EmptyState;
